module.exports = __webpack_public_path__ + "static/img/img.f228cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/img.png
// module id = QHKv
// module chunks = 0